/**
 * @desc 新增供应商sku报价保存草稿
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(body: defs.srm.SupplierQuotationRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/srm/supplierQuotation/saveDraft`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
